import { compareStatuses } from "pages/crawler/utils/crawlerStatusUtils";

type SortKey = string | number | null | undefined;

const normalizeString = (value: SortKey): string =>
  value === null || value === undefined ? "" : String(value);

const normalizeNumber = (value: SortKey): number => {
  if (typeof value === "number" && !Number.isNaN(value)) {
    return value;
  }
  if (typeof value === "string") {
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

const firstTimestamp = (item: any, fields: string[]): number => {
  for (const field of fields) {
    const value = item?.[field];
    if (!value) continue;
    const parsed = Date.parse(value);
    if (!Number.isNaN(parsed)) {
      return parsed;
    }
  }
  return Number.NEGATIVE_INFINITY;
};

export const makeStringAscComparator = (field: string) =>
  (a: any, b: any) => normalizeString(a?.[field]).localeCompare(normalizeString(b?.[field]), undefined, { numeric: true });

export const makeNumberDescComparator = (field: string) =>
  (a: any, b: any) => normalizeNumber(b?.[field]) - normalizeNumber(a?.[field]);

export const makeTimestampDescComparator = (fields: string[], tieBreaker?: (a: any, b: any) => number) =>
  (a: any, b: any) => {
    const diff = firstTimestamp(b, fields) - firstTimestamp(a, fields);
    if (diff !== 0 || !tieBreaker) {
      return diff;
    }
    return tieBreaker(a, b);
  };

export const makeStatusComparator = (
  getStatus: (item: any) => unknown,
  fallback: (a: any, b: any) => number
) => (a: any, b: any) => {
  const diff = compareStatuses(getStatus(a), getStatus(b));
  if (diff !== 0) {
    return diff;
  }
  return fallback(a, b);
};

